export const ADULTS_ONLY = 32;
export const ALL_INCLUSIVE = 2;
export const APARTMENT = 48;
export const BOUTIQUE = 49;
export const CITY = 12;
export const FAMILY = 17;
export const LUXURY = 50;
export const SUN_AND_BATH = 29;
